// import { createTheme } from "@material-ui/core/styles";
import { createTheme } from "@mui/material/styles";
import typography from "./Typography";
import shadows from "./Shadows";

// ##############################

// // // Global Variables
// ##############################

const SidebarWidth = 265;
const TopbarHeight = 70;

const lightPalette = {
  mode: "light",
  primary: {
    main: "#56C662",
    light: "#e6f4ff",
  },
  secondary: {
    main: "#1e4db7",
  },
  background: {
    default: "#fff",
    paper: "#fff",
  },
  success: {
    main: "#39cb7f",
    contrastText: "#ffffff",
  },
  danger: {
    main: "#fc4b6c",
  },
  error: {
    main: "#fc4b6c",
  },
  warning: {
    main: "#fdd43f",
    contrastText: "#ffffff",
  },
  text: {
    primary: "#2a3547",
    secondary: "#777e89",
    danger: "#fc4b6c",
  },
  divider: "rgba(0, 0, 0, 0.12)",
};

const darkPalette = {
  mode: "dark",
  primary: {
    main: "#56C662",
    light: "#1e3a24",
  },
  secondary: {
    main: "#7da2ff",
  },
  background: {
    default: "#12161f",
    paper: "#1c212b",
  },
  success: {
    main: "#39cb7f",
    contrastText: "#ffffff",
  },
  danger: {
    main: "#fc4b6c",
  },
  error: {
    main: "#fc4b6c",
  },
  warning: {
    main: "#fdd43f",
    contrastText: "#1c212b",
  },
  text: {
    primary: "#e6e9ef",
    secondary: "#9aa4b2",
    danger: "#fc4b6c",
  },
  divider: "rgba(255, 255, 255, 0.12)",
};

const getTheme = (mode = "light") =>
  createTheme({
    direction: "ltr",
    palette: mode === "dark" ? darkPalette : lightPalette,
    shape: {
      borderRadius: 5,
    },

    components: {
      MuiCssBaseline: {
        styleOverrides: {
          "*": {
            boxSizing: "border-box",
          },
          html: {
            height: "100%",
            width: "100%",
          },
          body: {
            height: "100%",
            margin: 0,
            padding: 0,
          },
          "#root": {
            height: "100%",
          },
        },
      },
      MuiContainer: {
        styleOverrides: {
          root: {
            paddingLeft: "15px !important",
            paddingRight: "15px !important",
            mx: 0,
            // maxWidth: "1600px",

            "@media(min-width:1200px)": {
              maxWidth: "100%",
            },
          },
        },
      },

      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
            boxShadow: "none",
            "&:hover": {
              boxShadow: "none",
            },
          },
        },
      },

      MuiListItem: {
        styleOverrides: {
          root: {
            borderRadius: "9px",
          },
        },
      },

      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: "20px",
            padding: "14px",
            margin: "15px",
          },
        },
      },

      MuiListItemIcon: {
        styleOverrides: {
          root: {
            minWidth: "40px",
          },
        },
      },

      MuiGridItem: {
        styleOverrides: {
          root: {
            paddingTop: "30px",
            paddingLeft: "30px !important",
          },
        },
      },
    },
    mixins: {
      toolbar: {
        color: "#949db2",
        "@media(min-width:1280px)": {
          minHeight: TopbarHeight,
          padding: "0 30px",
        },
        "@media(max-width:1280px)": {
          minHeight: "64px",
        },
      },
    },
    status: {
      danger: "#e53e3e",
    },
    typography,
    shadows,
  });

// Kept for backwards compatibility with any consumer that imports the
// pre-built light theme directly.
const baseTheme = getTheme("light");

export { TopbarHeight, SidebarWidth, baseTheme, getTheme };
